import React from 'react';
import  FacebookCircularProgress  from '../Elementos/FacebookCircularProgress';
import { Page, Text, View, Document, StyleSheet, Image as ImagePdf, Font, usePDF } from '@react-pdf/renderer';
import { Fab, Grid } from '@material-ui/core';
import { GetApp as GetAppIcon } from '@material-ui/icons';

const arrMeses = ['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

const PdfInstalacionRadio = ({ data, handleClickPdf, dataCliente, isOnuBridge, dataZona, getPlanes, getEquiposAll })=>{

    Font.register({family: 'Oswald',src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'});

    const styles = StyleSheet.create({
        imagesPdf:{
            width:'100vw',
            height:'100vh',
            padding:0,
        },
        imagesPdfFondo:{
            objectFit:'cover',
            width:'100%',
            marginTop:8,
            transform:'scale(1.05)'
        },
        fechaSuscripcion0_A1_1:{
            marginTop:-782,
            height:18,
            width:30,
            marginLeft:220,
            fontSize:9,
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            flexDirection:'row',
        },
        fechaSuscripcion0_A1_2:{
            marginTop:-18,
            height:18,
            width:62,
            marginLeft:260,
            fontSize:9,
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            flexDirection:'row',
        },
        fechaSuscripcion0_A1_3:{
            marginTop:-18,
            height:18,
            width:30,
            marginLeft:332,
            fontSize:9,
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            flexDirection:'row',
        },
        nombrePlan:{
            marginTop:3,
            height:18,
            width:300,
            marginLeft:158,
            fontSize:10,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
        },
        valPlan:{
            marginTop:0,
            height:18,
            width:60,
            marginLeft:94,
            fontSize:11,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        redAcceso:{
            marginTop:18,
            height:30,
            width:40,
            marginLeft:475,
            fontSize:12,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            position:'relative',
            top:14
        },
        cuentaVacio:{
            marginTop:35,
            height:31,
            width:295,
            marginLeft:225,
            fontSize:12,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        cuentaResidencial:{
            marginTop:35,
            height:31,
            width:295,
            marginLeft:225,
            fontSize:12,
            display:'flex',
            justifyContent:'flex-start',
            alignItems:'flex-start',
            flexDirection:'row',
        },
        cuentaCorporativo:{
            marginTop:35,
            height:31,
            width:295,
            marginLeft:225,
            fontSize:12,
            display:'flex',
            justifyContent:'flex-end',
            alignItems:'flex-start',
            flexDirection:'row',
        },
        cuentaCiber:{
            marginTop:35,
            height:31,
            width:295,
            marginLeft:225,
            fontSize:12,
            display:'flex',
            justifyContent:'flex-start',
            alignItems:'flex-end',
            flexDirection:'row',
        },
        cuentaOtros:{
            marginTop:35,
            height:31,
            width:295,
            marginLeft:225,
            fontSize:12,
            display:'flex',
            justifyContent:'flex-end',
            alignItems:'flex-end',
        },
        cuentaText:{
            textAlign:'center',
            width:50,
        },
        velocidad1:{
            marginTop:36,
            height:15,
            width:295,
            marginLeft:225,
            fontSize:10,
            display:'flex',
            flexWrap:'nowrap',
            flexDirection:'row',
            justifyContent:'space-between',
            alignItems:'center',
        },
        velocidad2:{
            marginTop:1,
            height:15,
            width:295,
            marginLeft:225,
            fontSize:10,
            display:'flex',
            flexWrap:'nowrap',
            flexDirection:'row',
            justifyContent:'space-between',
            alignItems:'center',
        },
        TiempoPermanencia:{
            marginTop:32,
            height:17,
            minWidth:45,
            maxWidth:70,
            marginLeft:490,
            fontSize:8,
            display:'flex',
            flexWrap:'nowrap',
            flexDirection:'row',
            justifyContent:'center',
            alignItems:'center',
            border:'1.3px solid #95A5A6',
            backgroundColor:'white'
        },
        ValInstalacion:{
            marginTop:180,
            height:14,
            width:90,
            marginLeft:306,
            fontSize:10,
            display:'flex',
            flexWrap:'nowrap',
            flexDirection:'row',
            justifyContent:'center',
            alignItems:'center',
        },
        ValPlan1:{
            marginTop:58,
            height:14,
            width:60,
            marginLeft:225,
            fontSize:10,
            display:'flex',
            flexWrap:'nowrap',
            flexDirection:'row',
            justifyContent:'center',
            alignItems:'center',
        },
        ValPlan2:{
            marginTop:15,
            height:14,
            width:60,
            marginLeft:225,
            fontSize:10,
            display:'flex',
            flexWrap:'nowrap',
            flexDirection:'row',
            justifyContent:'center',
            alignItems:'center',
        },
        NombreFirma:{
            marginTop:128,
            minHeight:14,
            width:200,
            marginLeft:325,
            fontSize:8,
            display:'flex',
            flexDirection:'row',
            justifyContent:'center',
            alignItems:'center',
        },
        CedulaFirma:{
            minHeight:14,
            width:200,
            marginLeft:325,
            fontSize:8,
            display:'flex',
            flexDirection:'row',
            justifyContent:'center',
            alignItems:'center',
        },
        CiudadA2:{
            marginTop:-741,
            height:13,
            width:90,
            marginLeft:146,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        fechaSuscripcionA2:{
            marginTop:-13,
            height:13,
            width:206,
            marginLeft:270,
            fontSize:10,
            display:'flex',
            justifyContent:'space-between',
            flexDirection:'row',
        },
        NombresA2:{
            marginTop:1.5,
            height:13,
            width:415,
            marginLeft:105,
            fontSize:9,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            textAlign:'center'
        },
        CedulaA2:{
            marginTop:1,
            height:13,
            width:120,
            marginLeft:360,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            textAlign:'center'
        },
        ProvinciaA2:{
            marginTop:1,
            height:13,
            width:90,
            marginLeft:415,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            textAlign:'center'
        },
        CantonA2:{
            marginTop:1,
            height:13,
            width:170,
            marginLeft:120,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            textAlign:'center',
        },
        ParroquiaA2:{
            marginTop:-13,
            height:13,
            width:150,
            marginLeft:370,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            textAlign:'center',
        },
        DireccionA2:{
            marginTop:0,
            height:25,
            width:395,
            marginLeft:125,
            fontSize:9,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'left',
            lineHeight:1.3,
        },
        CelularA2:{
            marginTop:1,
            height:13,
            width:95,
            marginLeft:180,
            fontSize:9,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            textAlign:'center',
        },
        CorreoA2:{
            marginTop:-13,
            height:13,
            width:170,
            marginLeft:372,
            fontSize:7,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        TiempoPermanenciaA2:{
            marginTop:213,
            height:13,
            width:38,
            marginLeft:339,
            fontSize:8,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            textAlign:'center',
        },
        NombresA2_2:{
            marginTop:163,
            height:13,
            width:390,
            marginLeft:140,
            fontSize:9,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        CedulaA2_2:{
            marginTop:11,
            height:13,
            width:200,
            marginLeft:100,
            fontSize:10,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        CiudadA2_2:{
            marginTop:57,
            height:13,
            width:108,
            marginLeft:174,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        fechaSuscripcionA2_1:{
            marginTop:-13,
            height:13,
            width:30,
            marginLeft:315,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        fechaSuscripcionA2_2:{
            marginTop:-13,
            height:13,
            width:90,
            marginLeft:410,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        fechaSuscripcionA2_3:{
            marginTop:-13,
            height:13,
            width:50,
            marginLeft:506,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        NombresA3:{
            marginTop:-756,
            height:13,
            width:317,
            marginLeft:235,
            fontSize:9,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        EquipoA3:{
            marginTop:229,
            height:13,
            width:67,
            marginLeft:41,
            fontSize:8,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        CantidadA3:{
            marginTop:-13,
            height:13,
            width:60,
            marginLeft:110,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        PrecioA3:{
            marginTop:-13,
            height:13,
            width:60,
            marginLeft:172,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        MacA3:{
            marginTop:-13,
            height:13,
            width:99,
            marginLeft:240,
            fontSize:9,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        MarcaA3:{
            marginTop:-13,
            height:13,
            width:76,
            marginLeft:389,
            fontSize:9,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        ModeloA3:{
            marginTop:-13,
            height:13,
            width:100,
            marginLeft:462,
            fontSize:7,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        EquipoA3_2:{
            marginTop:1.5,
            height:13,
            width:67,
            marginLeft:41,
            fontSize:8,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        ValorInstalacionA3:{
            marginTop:67.5,
            height:13,
            width:40,
            marginLeft:245,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        TiempoPermanenciaA3:{
            marginTop:0,
            height:13,
            width:24,
            marginLeft:58,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        CiudadA3_2:{
            marginTop:97.5,
            height:13,
            width:100,
            marginLeft:142,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        fechaSuscripcionA3_1:{
            marginTop:-13,
            height:13,
            width:19,
            marginLeft:268,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        fechaSuscripcionA3_2:{
            marginTop:-13,
            height:13,
            width:97,
            marginLeft:330,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        fechaSuscripcionA3_3:{
            marginTop:-13,
            height:13,
            width:47,
            marginLeft:470,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        NombresA3_2:{
            marginTop:59,
            height:13,
            width:250,
            marginLeft:109,
            fontSize:7,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        CedulaA3_2:{
            marginTop:-1.5,
            height:13,
            width:200,
            marginLeft:77,
            fontSize:10,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        NombresO:{
            marginTop:-205,
            height:13,
            width:300,
            marginLeft:77,
            fontSize:9,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        CedulaO:{
            marginTop:19,
            height:13,
            width:200,
            marginLeft:97,
            fontSize:10,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        fechaSuscripcionCE_1:{
            marginTop:-744,
            height:13,
            width:190,
            marginLeft:114,
            fontSize:11,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
        },
        boxCE:{
            marginTop:10,
            height:20,
            width:150,
            marginLeft:63,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            backgroundColor:'white'
        },
        NombresCE:{
            marginTop:403,
            height:13,
            width:300,
            marginLeft:195,
            fontSize:9,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            textAlign:'center',
        },
        CedulaCE:{
            marginTop:14,
            height:13,
            width:100,
            marginLeft:255,
            fontSize:11,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            textAlign:'center',
        },
        CiudadC1_1:{
            marginTop:-760,
            height:13,
            width:70,
            marginLeft:192,
            fontSize:8,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        fechaSuscripcionC1_1:{
            marginTop:-13,
            height:13,
            width:19,
            marginLeft:269,
            fontSize:8,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        fechaSuscripcionC1_2:{
            marginTop:-13,
            height:13,
            width:60,
            marginLeft:317,
            fontSize:8,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
        },
        fechaSuscripcionC1_3:{
            marginTop:-13,
            height:13,
            width:47,
            marginLeft:381,
            fontSize:8,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            backgroundColor:'white'
        },
        NombresC1:{
            marginTop:214,
            height:13,
            width:318,
            marginLeft:197,
            fontSize:8,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        CedulaC1:{
            marginTop:-1,
            height:13,
            width:100,
            marginLeft:145,
            fontSize:10,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        CorreoC1:{
            marginTop:-12,
            height:13,
            width:260,
            marginLeft:285,
            fontSize:8,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        DireccionC1:{
            marginTop:-2,
            height:25,
            width:380,
            marginLeft:140,
            fontSize:9,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'left',
            lineHeight:1.3,
        },
        ProvinciaC1:{
            marginTop:0,
            height:13,
            width:80,
            marginLeft:128,
            fontSize:8,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        CiudadC1:{
            marginTop:-13,
            height:13,
            width:80,
            marginLeft:304,
            fontSize:8,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        CantonC1:{
            marginTop:-13,
            height:13,
            width:80,
            marginLeft:428,
            fontSize:8,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        ParroquiaC1:{
            marginTop:-1,
            height:13,
            width:120,
            marginLeft:130,
            fontSize:8,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        DireccionC1_5:{
            marginTop:10,
            height:25,
            width:435,
            marginLeft:75,
            fontSize:9,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'left',
            lineHeight:1.2,
        },
        CelularC1:{
            marginTop:-2,
            height:13,
            width:230,
            marginLeft:295,
            fontSize:9,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        TiempoPermanenciaC1:{
            marginTop:323,
            height:13,
            width:80,
            marginLeft:91,
            fontSize:10,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        TiempoPermanenciaC2:{
            marginTop:-255,
            height:13,
            width:80,
            marginLeft:92,
            fontSize:10,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        TiempoPermanenciaC2_1:{
            marginTop:11,
            height:13,
            width:27,
            marginLeft:457,
            fontSize:10,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
            color:'grey'
        },
        CiudadC4:{
            marginTop:-269,
            height:13,
            width:72,
            marginLeft:362,
            fontSize:8,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',

        },
        fechaSuscripcionC4_1:{
            marginTop:-13,
            height:13,
            width:16,
            marginLeft:456,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',

        },
        fechaSuscripcionC4_2:{
            marginTop:0.5,
            height:13,
            width:50,
            marginLeft:114,
            fontSize:9,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        fechaSuscripcionC4_3:{
            marginTop:-13,
            height:13,
            width:47,
            marginLeft:206,
            fontSize:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
        },
        NombresC4:{
            marginTop:109,
            height:13,
            width:220,
            marginLeft:359,
            fontSize:8,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        CedulaC4:{
            marginTop:-2,
            height:13,
            width:190,
            marginLeft:345,
            fontSize:10,
            display:'flex',
            justifyContent:'flex-start',
            flexDirection:'row',
            textAlign:'center',
        },
        
    });

    const MyDoc = (
        <Document>
            <Page size='A4'>
                <View style={styles.imagesPdf}>
                    <ImagePdf source="ANEXO1.jpg" style={styles.imagesPdfFondo} />
                </View>
                <View style={styles.fechaSuscripcion0_A1_1}>                   
                    <Text>
                        {data.Instalacion.split('-')[2]}
                    </Text>
                </View>
                <View style={styles.fechaSuscripcion0_A1_2}>             
                    <Text>
                        {arrMeses[parseInt(data.Instalacion.split('-')[1])]}
                    </Text>
                </View>
                <View style={styles.fechaSuscripcion0_A1_3}>             
                    <Text>
                        {data.Instalacion.split('-')[0]} 
                    </Text>
                </View>
                <View style={styles.nombrePlan}>                   
                    <Text>
                        { getPlanes.filter(el=>el.PlanComercial === data.PlanComercial)[0]?.PlanComercial }
                    </Text>
                </View>
                <View style={styles.valPlan}>                   
                    <Text>
                        {data.ValPlan}
                    </Text>
                </View>
                <View style={styles.redAcceso}>                   
                    <Text>
                        X
                    </Text>
                </View>
                {
                    data.TipoCuenta ? 
                    <React.Fragment>
                    {
                        data.TipoCuenta === 'Corporativo'?
                        <View style={styles.cuentaCorporativo}>                   
                            <Text style={styles.cuentaText}>
                                X
                            </Text>
                        </View>:
                        data.TipoCuenta === 'Residencial'?
                        <View style={styles.cuentaResidencial}>                   
                            <Text style={styles.cuentaText}>
                                X
                            </Text>
                        </View>:
                        data.TipoCuenta === 'CiberCafe'?
                        <View style={styles.cuentaCiber}>                   
                            <Text style={styles.cuentaText}>
                                X
                            </Text>
                        </View>:
                        <View style={styles.cuentaOtros}>                   
                            <Text style={styles.cuentaText}>
                                X
                            </Text>
                        </View>
                    }
                    </React.Fragment>:
                    <View style={styles.cuentaVacio}>                   
                        
                    </View>
                }
                <View style={styles.velocidad1}>                   
                    <Text style={{width:52, height:15, textAlign:'center', position:'relative', top:3}}>
                        { getPlanes.filter(el=> el.PlanComercial === data.PlanComercial)[0]?.Bajada.toString()}
                    </Text>
                    <Text style={{width:52, height:15, textAlign:'center', position:'relative', top:1}}>
                        { getPlanes.filter(el=> el.PlanComercial === data.PlanComercial)[0]?.Subida.toString()}
                    </Text>
                </View>
                <View style={styles.velocidad2}>                   
                    <Text style={{width:52, height:15, textAlign:'center', position:'relative', top:3}}>
                        { getPlanes.filter(el=> el.PlanComercial === data.PlanComercial)[0]?.Bajada.toString()}
                    </Text>
                    <Text style={{width:52, height:15, textAlign:'center', position:'relative', top:1}}>
                        { getPlanes.filter(el=> el.PlanComercial === data.PlanComercial)[0]?.Subida.toString()}
                    </Text>
                </View>
                <View style={styles.TiempoPermanencia}>
                    <Text>
                        { `${data.TiempoPermanencia} Meses` }
                    </Text>
                </View>
                <View style={styles.ValInstalacion}>
                    <Text>
                        { `$${data.ValorInstalacion}` }
                    </Text>
                </View>
                <View style={styles.ValPlan1}>
                    <Text>
                        { `$${getPlanes.filter(el=> el.PlanComercial === data.PlanComercial)[0]?.Valor.toString()}` }
                    </Text>
                </View>
                <View style={styles.ValPlan2}>
                    <Text>
                        { `$${getPlanes.filter(el=> el.PlanComercial === data.PlanComercial)[0]?.Valor.toString()}` }
                    </Text>
                </View>
                <View style={styles.NombreFirma}>
                    <Text>
                        { dataCliente.Nombres.length > 42 ? dataCliente.CI : dataCliente.Nombres}
                    </Text>
                </View>
                <View style={styles.CedulaFirma}>
                    <Text style={{position:'relative', top:-2}}>
                        { dataCliente.Nombres.length > 42 ? '' : dataCliente.CI }
                    </Text>
                </View>
            </Page>
            <Page size='A4'>
                <View style={styles.imagesPdf}>
                    <ImagePdf source="ANEXO2.jpg" style={styles.imagesPdfFondo} />
                </View>
                <View style={styles.CiudadA2}>                   
                    <Text>
                        {data.Ciudad}
                    </Text>
                </View>
                <View style={styles.fechaSuscripcionA2}>                   
                    <Text>
                        {data.Instalacion.split('-')[2]}
                    </Text>
                    <Text style={{fontSize:10, position:'relative', left:7}}>
                        {arrMeses[parseInt(data.Instalacion.split('-')[1])]}
                    </Text>
                    <Text>
                        {data.Instalacion.split('-')[0]}
                    </Text>
                </View>
                <View style={styles.NombresA2}>
                    <Text>
                        { dataCliente.Nombres }
                    </Text>
                </View>
                <View style={styles.CedulaA2}>
                    <Text>
                        { dataCliente.CI }
                    </Text>
                </View>    
                <View style={styles.ProvinciaA2}>
                    <Text>
                        { data.Provincia }
                    </Text>
                </View>   
                <View style={styles.CantonA2}>
                    <Text>
                        { data.Canton }
                    </Text>
                </View>   
                <View style={styles.ParroquiaA2}>
                    <Text>
                        { data.Parroquia }
                    </Text>
                </View>  
                <View style={styles.DireccionA2} wrap>
                    <Text wrap>
                        { data.Direccion ? data.Direccion  : '' } 
                    </Text>
                </View>   
                <View style={styles.CelularA2}>
                    <Text>
                        { dataCliente.Celular[0].celular }
                    </Text>
                </View>   
                <View style={styles.CorreoA2}>
                    <Text>
                        { dataCliente.Correo[0].correo }
                    </Text>
                </View>     
                <View style={styles.TiempoPermanenciaA2}>
                    <Text>
                        { data.TiempoPermanencia }
                    </Text>
                </View>   
                <View style={styles.NombresA2_2}>
                    <Text>
                        { dataCliente.Nombres }
                    </Text>
                </View>     
                <View style={styles.CedulaA2_2}>
                    <Text>
                        { dataCliente.CI }
                    </Text>
                </View>  
                <View style={styles.CiudadA2_2}>                   
                    <Text>
                        {data.Ciudad}
                    </Text>
                </View>   
                <View style={styles.fechaSuscripcionA2_1}>                   
                    <Text>
                        {data.Instalacion.split('-')[2]}
                    </Text>
                </View>    
                <View style={styles.fechaSuscripcionA2_2}>                   
                    <Text>
                        {arrMeses[parseInt(data.Instalacion.split('-')[1])]}
                    </Text>
                </View>  
                <View style={styles.fechaSuscripcionA2_3}>                   
                    <Text>
                        {data.Instalacion.split('-')[0]}
                    </Text>
                </View>  
            </Page>
            <Page size='A4'>
                <View style={styles.imagesPdf}>
                    <ImagePdf source="ANEXO3.jpg" style={styles.imagesPdfFondo} />
                </View>
                <View style={styles.NombresA3}>                   
                    <Text>
                        {dataCliente.Nombres}
                    </Text>
                </View>
                <View style={styles.EquipoA3}>
                    <Text>
                        CPE
                    </Text>
                </View>
                <View style={styles.CantidadA3}>
                    <Text>
                       1
                    </Text>
                </View>
                <View style={styles.PrecioA3}>
                    <Text>
                        { `$${getEquiposAll.filter(el=> el.Modelo === data.Modelo)[0]?.Precio | ''}` }
                    </Text>
                </View>
                <View style={styles.MacA3}>
                    <Text>
                        { data.MacModelo}
                    </Text>
                </View>
                <View style={styles.MarcaA3}>
                    <Text>
                        { getEquiposAll.filter(el=> el.Modelo === data.Modelo)[0]?.Marca }
                    </Text>
                </View>
                <View style={styles.ModeloA3}>
                    <Text>
                        { getEquiposAll.filter(el=> el.Modelo === data.Modelo)[0]?.Modelo }
                    </Text>
                </View>
                <View style={styles.EquipoA3_2}>
                    <Text>
                        { data.MacRouter === '' ? '' : 'ROUTER'}
                    </Text>
                </View>
                <View style={styles.CantidadA3}>
                    <Text>
                        { data.MacRouter === '' ? '' : 1 }
                    </Text>
                </View>
                <View style={styles.PrecioA3}>
                    <Text>
                        { data.MacRouter === '' ? '' : `$${getEquiposAll.filter(el=> el.Modelo === data.Router)[0]?.Precio}` }
                    </Text>
                </View>
                <View style={styles.MacA3}>
                    <Text>
                        { data.MacRouter === '' ? '' : data.MacRouter }
                    </Text>
                </View>
                <View style={styles.MarcaA3}>
                    <Text>
                        { data.MacRouter === '' ? '' : getEquiposAll.filter(el=> el.Modelo === data.Router)[0]?.Marca }
                    </Text>
                </View>
                <View style={styles.ModeloA3}>
                    <Text>
                        { data.MacRouter === '' ? '' : getEquiposAll.filter(el=> el.Modelo === data.Router)[0]?.Modelo }
                    </Text>
                </View>
                <View style={styles.ValorInstalacionA3}>                   
                    <Text>
                        {`$${data.ValorInstalacionCompleta ? data.ValorInstalacionCompleta : 0}`}
                    </Text>
                </View>
                <View style={styles.TiempoPermanenciaA3}>                   
                    <Text>
                        {data.TiempoPermanencia ? data.TiempoPermanencia : 0}
                    </Text>
                </View>
                <View style={styles.CiudadA3_2}>                   
                    <Text>
                        {data.Ciudad}
                    </Text>
                </View>   
                <View style={styles.fechaSuscripcionA3_1}>                   
                    <Text>
                        {data.Instalacion.split('-')[2]}
                    </Text>
                </View>    
                <View style={styles.fechaSuscripcionA3_2}>                   
                    <Text>
                        {arrMeses[parseInt(data.Instalacion.split('-')[1])]}
                    </Text>
                </View>  
                <View style={styles.fechaSuscripcionA3_3}>                   
                    <Text>
                        {data.Instalacion.split('-')[0]}
                    </Text>
                </View>   
                <View style={styles.NombresA3_2}>
                    <Text>
                        { dataCliente.Nombres}
                    </Text>
                </View>     
                <View style={styles.CedulaA3_2}>
                    <Text>
                        { dataCliente.CI}
                    </Text>
                </View>  
            </Page>
            <Page size='A4'>
                <View style={styles.imagesPdf}>
                    <ImagePdf source="OBSERVACIONES.jpg" style={styles.imagesPdfFondo} />
                </View>
                <View style={styles.NombresO}>
                    <Text>
                        { dataCliente.Nombres}
                    </Text>
                </View>     
                <View style={styles.CedulaO}>
                    <Text>
                        { dataCliente.CI }
                    </Text>
                </View> 
            </Page>
            <Page size='A4'>
                <View style={styles.imagesPdf}>
                    <ImagePdf source="CENTRAL.jpg" style={styles.imagesPdfFondo} />
                </View>
                <View style={styles.fechaSuscripcionCE_1}>                   
                    <Text>
                        {`${data.Instalacion.split('-')[2]} de ${arrMeses[parseInt(data.Instalacion.split('-')[1])]} del ${data.Instalacion.split('-')[0]}`}
                    </Text>
                </View>  
                <View style={styles.boxCE}>                   
                </View> 
                <View style={styles.NombresCE}>
                    <Text>
                        { dataCliente.Nombres}
                    </Text>
                </View>     
                <View style={styles.CedulaCE}>
                    <Text>
                        { dataCliente.CI }
                    </Text>
                </View> 
            </Page>
            <Page size='A4'>
                <View style={styles.imagesPdf}>
                    <ImagePdf source="CONTRATO1.jpg" style={styles.imagesPdfFondo} />
                </View>
                <View style={styles.CiudadC1_1}>                   
                    <Text>
                        {data.Ciudad}
                    </Text>
                </View>   
                <View style={styles.fechaSuscripcionC1_1}>                   
                    <Text>
                        {data.Instalacion.split('-')[2]}
                    </Text>
                </View>    
                <View style={styles.fechaSuscripcionC1_2}>                   
                    <Text>
                        {arrMeses[parseInt(data.Instalacion.split('-')[1])]}
                    </Text>
                </View>  
                <View style={styles.fechaSuscripcionC1_3}>                   
                    <Text>
                        {data.Instalacion.split('-')[0]}
                    </Text>
                </View>  
                <View style={styles.NombresC1}>
                    <Text>
                        { dataCliente.Nombres }
                    </Text>
                </View>     
                <View style={styles.CedulaC1}>
                    <Text>
                        { dataCliente.CI }
                    </Text>
                </View> 
                <View style={styles.CorreoC1}>
                    <Text>
                        { dataCliente.Correo[0].correo }
                    </Text>
                </View> 
                <View style={styles.DireccionC1} wrap>
                    <Text wrap>
                        { data.Direccion ? data.Direccion  : '' }
                    </Text>
                </View>
                <View style={styles.ProvinciaC1}>
                    <Text>
                        { data.Provincia }
                    </Text>
                </View>     
                <View style={styles.CiudadC1}>
                    <Text>
                        { data.Ciudad }
                    </Text>
                </View> 
                <View style={styles.CantonC1}>
                    <Text>
                        { data.Canton }
                    </Text>
                </View> 
                <View style={styles.ParroquiaC1}>
                    <Text>
                        { data.Parroquia }
                    </Text>
                </View> 
                <View style={styles.DireccionC1_5} wrap>
                    <Text wrap>
                        { data.Direccion ? data.Direccion  : '' }
                    </Text>
                </View>
                <View style={styles.CelularC1}>
                    <Text>
                        { dataCliente.Celular[0].celular }
                    </Text>
                </View>
                <View style={styles.TiempoPermanenciaC1}>
                    <Text>
                        { `${data.TiempoPermanencia ? data.TiempoPermanencia : 0} Meses` }
                    </Text>
                </View>
               
            </Page>
            <Page size='A4'>
                <View style={styles.imagesPdf}>
                    <ImagePdf source="CONTRATO2.jpg" style={styles.imagesPdfFondo} />
                </View>
                <View style={styles.TiempoPermanenciaC2}>
                    <Text>
                        { `${data.TiempoPermanencia ? data.TiempoPermanencia : 0 } Meses` }
                    </Text>
                </View>
                <View style={styles.TiempoPermanenciaC2_1}>
                    <Text>
                        { data.TiempoPermanencia ? data.TiempoPermanencia : 0 }
                    </Text>
                </View>
            </Page>
            <Page size='A4'>
                <View style={styles.imagesPdf}>
                    <ImagePdf source="CONTRATO3.jpg" style={styles.imagesPdfFondo} />
                </View>
            </Page>
            <Page size='A4'>
                <View style={styles.imagesPdf}>
                    <ImagePdf source="CONTRATO4.jpg" style={styles.imagesPdfFondo} />
                </View>
                <View style={styles.CiudadC4}>                   
                    <Text>
                        {data.Ciudad}
                    </Text>
                </View>   
                <View style={styles.fechaSuscripcionC4_1}>                   
                    <Text>
                        {data.Instalacion.split('-')[2]}
                    </Text>
                </View>    
                <View style={styles.fechaSuscripcionC4_2}>                   
                    <Text>
                        {arrMeses[parseInt(data.Instalacion.split('-')[1])]}
                    </Text>
                </View>  
                <View style={styles.fechaSuscripcionC4_3}>                   
                    <Text>
                        {data.Instalacion.split('-')[0]}
                    </Text>
                </View>  
                <View style={styles.NombresC4}>
                    <Text>
                        { dataCliente.Nombres.length > 42 ? '' :  dataCliente.Nombres }
                    </Text>
                </View>     
                <View style={styles.CedulaC4}>
                    <Text>
                        {  dataCliente.CI }
                    </Text>
                </View>  
            </Page>
        </Document>
    );

    const [ instance ] = usePDF({ document: MyDoc });

    if (instance.loading) return (
        <Grid container justifyContent='flex-start' alignItems='flex-start' style={{width: '100%', height:'100%'}}>
           <Grid item style={{alignSelf: 'center', padding:1}}>
                <FacebookCircularProgress size={30} />
            </Grid>
        </Grid>
    );

    if (instance.error) return <div>Something went wrong: {instance.error}</div>;


    return (
        <Grid container justifyContent='flex-start' alignItems='flex-start' style={{width: '100%', height:'100%'}}>
            <Grid item style={{alignSelf: 'center'}}>
                <Fab href={instance.url} target="_blank" onClick={handleClickPdf} size='small'  color='secondary'>
                    <GetAppIcon />
                </Fab>
            </Grid>
        </Grid>
    );
};
export default PdfInstalacionRadio;